module.exports = __webpack_public_path__ + "static/publication-cover-065b0e48f558ab2b34f9993cd0da9c09.png";